module.exports = __webpack_public_path__ + "static/media/text_tag.165d6106.svg";